import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { FaGithub, FaExternalLinkAlt, FaCheck, FaEnvelope } from 'react-icons/fa';
import './index.scss';

interface Project {
  id: string;
  name: string;
  description: string;
  technologies: string[];
  image: string;
  github?: string;
  demo?: string;
}

const ProjectsPage: React.FC = () => {
  const [copied, setCopied] = useState(false);

  const handleCopyEmail = async () => {
    try {
      await navigator.clipboard.writeText('1466717763@qq.com');
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error('Failed to copy:', err);
      window.location.href = 'mailto:1466717763@qq.com';
    }
  };

  const projects: Project[] = [
    {
      id: '1',
      name: '个人博客系统',
      description: '一个现代化的个人博客系统，采用React + TypeScript开发，具有美观的设计和优秀的用户体验。',
      technologies: ['React', 'TypeScript', 'Sass', 'Framer Motion'],
      image: 'https://picsum.photos/seed/blog/800/450',
      github: 'https://github.com',
      demo: '#'
    },
    {
      id: '2',
      name: '在线学习平台',
      description: '一个功能完善的在线学习平台，支持视频播放、课程管理、用户互动等功能。',
      technologies: ['React', 'Node.js', 'MySQL', 'Redis'],
      image: 'https://picsum.photos/seed/learning/800/450',
      github: 'https://github.com'
    },
    {
      id: '3',
      name: '企业管理系统',
      description: '为企业打造的管理系统，包含员工管理、权限控制、数据统计等功能。',
      technologies: ['Spring Boot', 'Vue', 'MySQL', 'Docker'],
      image: 'https://picsum.photos/seed/enterprise/800/450',
      demo: '#'
    },
    {
      id: '4',
      name: '电商平台',
      description: '一个完整的电商解决方案，包含商品展示、购物车、订单管理、支付集成等功能。',
      technologies: ['React', 'Node.js', 'MongoDB', 'Stripe'],
      image: 'https://picsum.photos/seed/ecommerce/800/450',
      github: 'https://github.com'
    },
    {
      id: '5',
      name: '即时通讯应用',
      description: '一个实时通讯应用，支持文字、语音、图片消息，以及群聊功能。',
      technologies: ['React Native', 'Socket.io', 'MongoDB'],
      image: 'https://picsum.photos/seed/messaging/800/450',
      github: 'https://github.com'
    },
    {
      id: '6',
      name: '数据分析仪表板',
      description: '一个可视化的数据分析平台，支持数据导入、图表展示、报表导出等功能。',
      technologies: ['React', 'D3.js', 'Python', 'PostgreSQL'],
      image: 'https://picsum.photos/seed/analytics/800/450',
      demo: '#'
    }
  ];

  return (
    <section className="projects-page">
      <div className="container">
        <motion.div 
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="page-header"
        >
          <h1>项目展示</h1>
          <p>探索我参与的各种项目，从前端到后端，从移动端到数据可视化</p>
        </motion.div>

        <div className="projects-grid">
          {projects.map((project, index) => (
            <motion.div
              key={project.id}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              viewport={{ once: true }}
              whileHover={{ y: -10, boxShadow: '0 20px 40px rgba(66, 153, 225, 0.2)' }}
              className="project-card"
            >
              <div className="project-image">
                <img src={project.image} alt={project.name} />
                <div className="project-overlay">
                  <div className="project-links">
                    {project.github && (
                      <a href={project.github} target="_blank" rel="noopener noreferrer" className="project-link">
                        <FaGithub />
                      </a>
                    )}
                    {project.demo && (
                      <a href={project.demo} target="_blank" rel="noopener noreferrer" className="project-link">
                        <FaExternalLinkAlt />
                      </a>
                    )}
                  </div>
                </div>
              </div>
              <div className="project-content">
                <h3 className="project-name">{project.name}</h3>
                <p className="project-description">{project.description}</p>
                <div className="project-technologies">
                  {project.technologies.map((tech, techIndex) => (
                    <span key={techIndex} className="tech-tag">{tech}</span>
                  ))}
                </div>
              </div>
            </motion.div>
          ))}
        </div>

        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.3 }}
          viewport={{ once: true }}
          className="contact-section"
        >
          <h2>有项目合作意向？</h2>
          <p>欢迎通过以下方式联系我，共同探讨合作机会</p>
          <button onClick={handleCopyEmail} className="btn-contact">
            {copied ? <><FaCheck /> 已复制!</> : <><FaEnvelope /> 联系我</>}
          </button>
        </motion.div>
      </div>
    </section>
  );
};

export default ProjectsPage;